import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { Button, Icon, Input, Modal, DatePicker, LocaleProvider, Select } from 'antd';
import ruRU from 'antd/lib/locale-provider/ru_RU';
import { isEmpty, pick, omit, debounce } from 'lodash';
import moment from 'moment';
import 'moment/locale/ru';

import { ruLocale } from 'shared/utils/locale';
import { emailRegex, noNumberRegex } from 'shared/utils/constants';
import { highlight } from 'shared/utils/formatter';
import { getUserInfo, searchUsers } from 'Root/http';

import s from './style/EditUserModal.pcss';


function getTitle(isEdit) {
  return isEdit
    ? 'Вы можете изменить информацию о пользователе'
    : 'Введите email, чтобы пользователь получил письмо со ссылкой доступа к Системе.';
}

const ruRU_format = {
  ...ruRU,
  DatePicker: {
    ...ruRU.DatePicker,
    ...ruLocale,
  },
};

const Option = Select.Option;

const initialState = {
  email: '',
  firstName: '',
  lastName: '',
  patronymicName: '',
  companyName: '',
  expiredDate: undefined,
  initiator: {},
  initiatorInputValue: '',
  initiatorData: [],
  isAdding: false,
  errors: {},
};

export default class EditUserModal extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    let state = initialState;
    if (this.props.user.id) {
      state = { ...state, ...this.props.user };
      state.expiredDate = state.expiredDate ? moment(state.expiredDate) : undefined;
      state.initiator = state.initiatorId || {};
    }
    this.state = state;
  }

  static defaultProps = {
    user: {},
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.visible && !nextProps.visible) {
      this.setState(initialState);
    } else {
      const state = { ...initialState, ...nextProps.user };
      state.expiredDate = state.expiredDate ? moment(state.expiredDate) : undefined;
      state.initiator = state.initiatorId || {};
      this.setState(state);
    }
  }

  onSelectChange = (value) => {
    const errors = omit(this.state.errors, ['initiatorId']);
    this.setState({
      initiator: this.state.initiatorData.find(item => item.id === value),
      initiatorData: [],
      errors,
    });
  };
  onSearch = (value) => {
    const body = { value, pageSize: 5 };
    searchUsers(body)
      .then((res) => {
        const initiatorData = res.list;
        this.setState({ initiatorData, initiatorInputValue: value });
      });
  };
  debounceSearch = debounce(this.onSearch, 500);

  changeForm = field => (param) => {
    if (field === 'expiredDate') {
      this.setState({ [field]: param });
    } else {
      const errors = omit(this.state.errors, [field]);
      if (field === 'email') {
        delete errors.isUserExisted;
      }
      const newState = { [field]: param.target.value, errors };
      this.setState(newState);
    }
  };

  getErrors = () => {
    const { firstName, lastName, patronymicName, email, companyName, initiator } = this.state;
    const errors = {};
    if (!firstName || !firstName.match(noNumberRegex)) {
      errors.firstName = 'Некорректное имя';
    }
    if (!lastName || !lastName.match(noNumberRegex)) {
      errors.lastName = 'Некорректная фамилия';
    }
    if (!patronymicName || !patronymicName.match(noNumberRegex)) {
      errors.patronymicName = 'Некорректное отчество';
    }
    if (!email || !email.match(emailRegex)) {
      errors.email = 'Некорректный email';
    }
    if (!companyName) {
      errors.companyName = 'Необходимо заполнить поле';
    }
    if (!initiator.id) {
      errors.initiatorId = 'Необходимо заполнить поле';
    }
    return errors;
  };

  handleSubmit = () => {
    const errors = this.getErrors();
    if (isEmpty(errors)) {
      const data =
        pick(this.state, ['firstName', 'lastName', 'patronymicName', 'companyName', 'email']);
      if (this.state.expiredDate) {
        data.expiredDate = this.state.expiredDate.toISOString();
      }
      if (this.state.initiator) {
        data.initiatorId = this.state.initiator.id;
      }
      if (this.props.user.id) {
        data.id = this.props.user.id;
        this.setState({ isAdding: true }, () => {
          this.props.onEdit(data).then(() => {
            this.setState(initialState);
          });
        });
      } else {
        const userId = data.email.toLowerCase();
        this.setState({ isAdding: true }, () => {
          getUserInfo(userId).then((existedUser) => {
            if (existedUser) {
              const newErrors = { ...errors, email: true, isUserExisted: true };
              this.setState({ errors: newErrors, isAdding: false });
            } else {
              data.id = userId;
              this.props.onEdit(data)
                .then(() => this.setState({ isAdding: false }));
            }
          });
        });
      }
    } else {
      this.setState({ errors });
    }
  };

  renderTitle = () => {
    const { user } = this.props;
    return (
      <div className={s.title}>
        <div className={s.titleHint}>
          {user.id
            ? `Редактировать пользователя "${user.lastName} ${user.firstName} ${user.patronymicName}"`
            : 'Новый пользователь'
          }
        </div>
        <div className={s.closeModalCls} onClick={this.props.onClose}>
          <Icon type="close" />
        </div>
      </div>
    );
  };

  render() {
    const { visible, user } = this.props;
    const {
      errors, companyName, email, firstName,
      lastName, patronymicName, expiredDate, initiator, initiatorData, initiatorInputValue, isAdding,
    } = this.state;
    return (
      <div>
        <Modal
          title={null}
          footer={null}
          visible={visible}
          closable={false}
          destroyOnClose
          width={'642px'}
          bodyStyle={{
            minHeight: '294px',
            overflow: 'hidden',
            padding: '15px',
          }}
          getContainer={() => ReactDOM.findDOMNode(this)}
        >
          {this.renderTitle()}
          <div className={s.hint}>
            {getTitle(!!user.id)}
          </div>
          <div className={s.row}>
            <div className={s.valueContainer}>
              <div className={s.label}>Фамилия</div>
              <Input
                className={`${s.inputCls} ${errors.lastName ? s.noValid : ''}`}
                onChange={this.changeForm('lastName')}
                value={lastName}
              />
            </div>
            <div className={s.valueContainer}>
              <div className={s.label}>Имя</div>
              <Input
                className={`${s.inputCls} ${errors.firstName ? s.noValid : ''}`}
                onChange={this.changeForm('firstName')}
                value={firstName}
              />
            </div>
            <div className={s.valueContainer}>
              <div className={s.label}>Отчество</div>
              <Input
                className={`${s.inputCls} ${errors.patronymicName ? s.noValid : ''}`}
                onChange={this.changeForm('patronymicName')}
                value={patronymicName}
              />
            </div>
          </div>
          <div className={s.row}>
            <div className={s.valueContainer}>
              <div className={s.label}>Email</div>
              <Input
                className={`${s.inputCls} ${errors.email ? s.noValid : ''}`}
                onChange={this.changeForm('email')}
                value={email}
              />
            </div>
            <div className={s.valueContainer}>
              <div className={s.label}>Компания</div>
              <Input
                className={`${s.inputCls} ${errors.companyName ? s.noValid : ''}`}
                onChange={this.changeForm('companyName')}
                value={companyName}
              />
            </div>
          </div>
          <div className={s.row}>
            <div className={s.valueContainer}>
              <div className={s.label}>Инициатор</div>
              <Select
                placeholder="Выбрать"
                value={initiator.fullName}
                showArrow={false}
                showSearch
                defaultActiveFirstOption={false}
                filterOption={false}
                notFoundContent={null}
                className={`${s.select} ${errors.initiatorId ? s.noValid : ''}`}
                dropdownClassName={s.dropdown}
                onChange={this.onSelectChange}
                onSearch={this.debounceSearch}
              >
                {initiatorData.map(item => (
                  <Option value={item.id} key={item.id}>
                    <div
                      className={s.name}
                      dangerouslySetInnerHTML={{ __html: highlight(item.fullName, initiatorInputValue) }}
                    />
                    <div
                      className={s.email}
                      dangerouslySetInnerHTML={{ __html: highlight(item.email, initiatorInputValue) }}
                    />
                  </Option>
                ))}
              </Select>
            </div>
            <div className={s.valueContainer}>
              <div className={s.label}>Срок</div>
              <LocaleProvider locale={ruRU_format}>
                <DatePicker
                  value={expiredDate}
                  onChange={this.changeForm('expiredDate')}
                  format="DD MMMM YYYY"
                />
              </LocaleProvider>
            </div>
          </div>
          <div className={s.footer}>
            <Button
              type="primary"
              className={s.addBtn}
              disabled={!isEmpty(errors) || isAdding}
              onClick={this.handleSubmit}
            >
              {user.id ? 'Редактировать' : 'Добавить пользователя'}
            </Button>
            <div className={s.userExistedError}>
              {errors.isUserExisted ? 'Пользователь с такой почтой уже существует' : ''}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Users/EditUserModal.js